import OspreyAffiliationsSearch from './affiliations-search'

export default class Affiliations {
    search(dataKey) {
        return new OspreyAffiliationsSearch(dataKey)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/affiliations/index.js